'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import ExperienceCenterLocationSpecific, {ExperienceCenterLocationSpecificProps} from 'components/commercetools-ui/organisms/experience-center/location-specific';


const ExperienceCenterLocationSpecificTastic  = ({ data }: TasticProps<ExperienceCenterLocationSpecificProps>) => {
  return <ExperienceCenterLocationSpecific data={data?.data?.dataSource} />;
};

export default ExperienceCenterLocationSpecificTastic;